export const getEnumKeyByValue = <T extends { [key: string]: string }>(
  enumObj: T,
  value?: string | string[]
): keyof T | undefined | string => {
  const keys = Object.keys(enumObj) as Array<keyof T>;

  if (!value) {
    return undefined;
  }

  // value가 배열인 경우
  if (Array.isArray(value)) {
    const mappedValues = value.map((item) => keys.find((key) => enumObj[key] === item)).filter(Boolean); // undefined 값 제거

    return mappedValues.join(', ');
  }

  // value가 단일 문자열인 경우
  return keys.find((key) => enumObj[key] === value);
};
